import {
  Box,
  Button,
  Checkbox,
  Fade,
  MenuItem,
  Paper,
  Popper,
  PopperPlacementType,
  Select,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  IconButton,
} from "@mui/material";
import DangerousRoundedIcon from '@mui/icons-material/DangerousRounded';
// import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import api from "../../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';
import { DetailTrans } from "../prc/TzaDetailDialog";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { SearchBackDrop } from "../../component/common/SearchBackDrop";
import CustomPagination from "../../component/common/CustomPagination";
import EvalTextViewPage from "../EvalTextViewPage";
import EvalJsonDialog from "../EvalJsonDialog";


const initailEvknData: any = {
  idx : -1,

  task: "simpleqa",
  data_sources: "",
  category: "",
  subcategory: "",
  bmk_pk: "",
  difficulty: "",
  keyword: "",
  title: "",
  text: "",
  
  qa_type: "",
  answer_type: "",
  science_fact: "",
  common_knowledge: "",
  
  activity: "",
  question_a: "",
  question_b: "",
  question: "",

  answer: "",
  answer_index: "",

  option_1: "",
  option_2: "",
  option_3: "",
  option_4: "",
  option_5: "",

  reason_1: "",
  reason_2: "",
  reason_3: "",
  reason_4: "",
  reason_5: "",

  job_user:"",
  job_date:"",
  des:"",
};

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const EvknOpenBookPage = (props: any) => {

  const [pageType, setPageType] = useState("new")

  const [openJsonDialog, setOpenJsonDialog] = useState<boolean>(false)

  const [search_doc_id, setSearch_doc_id] = useState("")

  const [evkn_detail_data, setEvkn_detail_data] = useState<any>(initailEvknData);

  const [page, setPage] = useState(1);
  const [c_page, setC_page] = useState("")
  const [order, setOrder] = useState('desc');
  const [total_cnt, setTotal_cnt] = useState(0);
  
  const [pagination, setPagination] = useState<pageInfoType | undefined>(undefined);

  const [evknWorkList, setEvknWorkList] = useState([]);

  const [idx, setIdx] = useState('');
  const [job_yn, setJob_yn] = useState('모두');
  const [gub_cd, setGub_cd] = useState('모두');


  const [backdrop, setBackdrop] = useState<boolean>(false)

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)

  function normalizeReasonPathToString(input: any): string {
    if (!input) return "[]";
    if (Array.isArray(input)) return JSON.stringify(input);
    try {
      const parsed = JSON.parse(input);
      return Array.isArray(parsed) ? JSON.stringify(parsed) : "[]";
    } catch {
      return "[]";
    }
  }

  const updateColEvknData = async (gub: any) => {

    setBackdrop(true)
    
    const formData = new FormData();

    formData.append("email", email);

    formData.append("worker", worker);

    formData.append("gub", gub);

    const updatedColEvknData = {
      ...prcOpenBookData,
      reason_path: Array.isArray(reason_path) ? reason_path : (() => {
        try { return JSON.parse(reason_path as string); } catch { return []; }
      })(),
      options: Array.isArray(options) ? options : (() => {
        try { return JSON.parse(options as string); } catch { return []; }
      })(),
    };

    formData.append("prcOpenBookData", JSON.stringify(updatedColEvknData));

    await api.post("/updatePrcOpenBookData",formData)
    .then((res:any) => {alert(updatedColEvknData.idx + " 데이터 검수 완료"); setPageType("update"); setBackdrop(false); getEvknWorkList();})
    .catch((error:any) => {alert('오류 - '+ error.response.data.error); setBackdrop(false);})

  }

  const [prcOpenBookData, setPrcOpenBookData] = useState<any>([]);

  const [common_knowledge, setCommon_knowledge] = useState<any>([]);

  const [reason_path, setReason_path] = useState<any>([]);

  const reason_path_change = (idx: number, val: string) => {
    setReason_path((prev:any) => {
      const next = [...prev];
      next[idx] = val;
      return next;
    });
  };

  const [options, setOptions] = useState<any>([]);

  const options_change = (idx: number, val: string) => {
    setOptions((prev:any) => {
      const next = [...prev];
      next[idx] = val;
      return next;
    });
  };

  const handleAdd = () => setReason_path((prev) => [...prev, ""]);
  const handleRemove = (idx: number) =>
    setReason_path((prev) => prev.filter((_, i) => i !== idx));

  const search_data = useCallback(async () => {
      api.get('/getColEvknData', {params:{email:email,idx:search_doc_id}})
      .then((res:any) => {console.log("EVKN 데이터 조회 ", res.data.datas[0]); setPrcOpenBookData(res.data.datas[0]); })
      .catch((error:any) => {console.error('에러',error.response);})
    },[search_doc_id])

  const updateKeep = async () => {

    const formData = new FormData();

    formData.append("email", email);

    formData.append("document_id", search_doc_id);

    await api.post("/updateColEvknData-keep",formData)
    .then((res:any) => { alert("데이터가 선정되었습니다."); })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})

  }

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  const getEvknWorkList = async () => {
    

    setBackdrop(true)
    api.get('/evknOpenBookWorkList',{params:{email:email, worker:worker, page:page, order:order, job_yn:job_yn, gub_cd:gub_cd, idx:idx}})
    .then((res:any) => {
      
      if(res.data.datas.length > 0){
        setEvknWorkList(res.data.datas);

        if((prcOpenBookData && prcOpenBookData.idx == -1) || (pagination && page != pagination.current_page)){
          setPrcOpenBookData(res.data.datas[0])
        }

        setPagination(res.data.pagination)
        setTotal_cnt(res.data.pagination.total_count)
      }else{
        setEvknWorkList(res.data.datas);
        setPagination(res.data.pagination)
        setTotal_cnt(0)
      }
      setBackdrop(false)
      })
    .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
  }

  useEffect(() => {
    if(props.rowDetail != undefined){
      if(props.rowDetail.instruction_data == 'Y'){
        setPageType("update")
      }else{
        setEvkn_detail_data(initailEvknData);
        setPageType("new")
      }
    }
    getEvknWorkList()
  }, [page, props.rowDetail]);

  return (
    <Paper sx={{width:"100%", overflow: "auto"}}>
      {backdrop && ( <SearchBackDrop message={"처리중..."}/> )}
      <Box sx={{margin:"1px 20px 0px 20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>지식 - 데이터 검수</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      <Box display="flex">

      <Box>
        <EvalTextViewPage sid={prcOpenBookData.source_id} c_s={prcOpenBookData.char_start} c_e={prcOpenBookData.char_end} />
        {/* <EvalTextViewPage sid={prcOpenBookData.source_id} /> */}
      </Box>
        {/* <Box display="flex">
          <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#acdffc"}}>
            <Box sx={{width:"800px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
              <Box sx={{display:"flex", alignItems:"center"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{display:"flex", alignItems:"center", justifyContent:"left"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"120px"}}>document_id</Box>
                      <TextField
                        value={search_doc_id}
                        onChange={(e) => setSearch_doc_id(e.target.value)}
                        variant="outlined"
                        size="small"
                        sx={{ width: "300px", mr: 1 ,backgroundColor: "#fff"}}
                      />
                      <Button variant="contained" onClick={search_data}>
                        조회
                      </Button>

                      <Button sx={{ marginLeft: "100px"}} variant="contained" color="secondary" onClick={updateKeep}>
                        데이터 선정
                      </Button>
                    </Box>
                    <Box sx={{alignItems:"center", justifyContent:"center"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>주제분류 (CATEGORY)</Box>
                      <Select id="topic_cd" value={prcOpenBookData.category || ""} onChange={(e) => {setPrcOpenBookData({ ...prcOpenBookData, category: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"790px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                        <MenuItem dense value={""}>선택하세요</MenuItem>
                        <MenuItem dense value={"101"}>한국형-역사</MenuItem>
                        <MenuItem dense value={"102"}>한국형-문화</MenuItem>
                        <MenuItem dense value={"103"}>한국형-사회</MenuItem>
                        <MenuItem dense value={"104"}>한국형-지리</MenuItem>
                        <MenuItem dense value={"105"}>한국형-언어</MenuItem>
                        <MenuItem dense value={"106"}>한국형-정치및법</MenuItem>
                        <MenuItem dense value={"201"}>글로벌-일반상식</MenuItem>
                        <MenuItem dense value={"202"}>글로벌-과학</MenuItem>
                        <MenuItem dense value={"203"}>글로벌-인문학및사회학</MenuItem>
                        <MenuItem dense value={"204"}>글로벌-공학및기술</MenuItem>
                        <MenuItem dense value={"205"}>글로벌-경제</MenuItem>
                        <MenuItem dense value={"206"}>글로벌-기타</MenuItem>
                      </Select>
                      <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                      <Box><textarea value={prcOpenBookData.keyword} onChange={(e) => {setPrcOpenBookData({ ...prcOpenBookData, keyword: e.target.value });}} spellCheck="false" style={{width:"790px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>
                    </Box>
                    <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                    <Box><textarea value={prcOpenBookData.title} onChange={(e) => {setPrcOpenBookData({ ...prcOpenBookData, title: e.target.value });}} spellCheck="false" style={{width:"790px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                    <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                    <Box><textarea value={prcOpenBookData.text} onChange={(e) => {setPrcOpenBookData({ ...prcOpenBookData, text: e.target.value });}} spellCheck="false" style={{width:"790px",minHeight:"520px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                  </Box>
                </Box>
              </Box>
            </Box>
          </Paper>
        </Box> */}


        {/* OPENBOOK */}
        <Box display="flex">
          <Box sx={{width:"100%"}}>
            <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#ffdcf5"}}>
              {/* <Box sx={{fontSize:"20px", fontWeight:700, textAlign:"center", margin:"2px"}}>OPENBOOKQA</Box> */}
              <Box display="flex" justifyContent="center">
                <Box sx={{fontSize:"20px", fontWeight:700, textAlign:"center", margin:"2px"}}>OPENBOOKQA</Box>
                <Button variant="contained" size="small" sx={{marginLeft:"32px",fontWeight:700, backgroundColor:"#e79055"}} onClick={() => setOpenJsonDialog(true)}>
                  OPEN JSON
                </Button>
              </Box>
              {openJsonDialog ? <EvalJsonDialog className="json-dialog-content" data={prcOpenBookData.json_data} setOpenJsonDialog={setOpenJsonDialog} />:<></>}
              <Box display="flex">
                <Box>
                  <Box sx={{margin:"4px"}}>
                    <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                      <Box>
                        <Box sx={{margin:"0px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                        <Box><textarea spellCheck="false" value={prcOpenBookData.question || ""} onChange={(e) => {setPrcOpenBookData({ ...prcOpenBookData, question: e.target.value });}} style={{border:"4px solid #000", width:"380px",minHeight:"240px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                      </Box>
                    </Box>
                  </Box>

                </Box>
                <Box>
                  <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Options</Box>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"8px", alignItems:"center"}}>
                      {options && options.map((item:any, index:any) => 
                        <Box key={"Box_Options"+index} sx={{display:"flex", margin:"8px 0px 0px 2px", fontWeight:700}}>
                          <Box sx={{ width: "28px", fontWeight: 700, lineHeight: "28px", color:(prcOpenBookData.answer === (String.fromCharCode(65 + index)) ? "red" : "#000") }}>{String.fromCharCode(65 + index)}.</Box>
                          <textarea key={index} readOnly={prcOpenBookData.answer === String.fromCharCode(65 + index)} spellCheck="false" value={item || ""} onChange={prcOpenBookData.answer !== (String.fromCharCode(65 + index)) ? (e:any) => options_change(index, e.target.value) : undefined} style={{width:"440px",minHeight:"20px", fontSize:"14px", fontWeight:600,padding:"2px", backgroundColor:(prcOpenBookData.answer === (String.fromCharCode(65 + index)) ? "#f0ffea" : "#fff"), fontFamily: "Noto Sans KR"}}  />
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box display="flex">
                <Box>
                  <Box sx={{margin:"4px"}}>
                    <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                      <Box>
                        <Box sx={{margin:"0px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Science_fact</Box>
                        <Box><textarea spellCheck="false" readOnly={true} value={prcOpenBookData.science_fact || ""} style={{border:"4px solid #000", width:"360px",minHeight:"80px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{margin:"4px"}}>
                    <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                      <Box>
                        <Box sx={{margin:"0px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>doc_fact</Box>
                        <Box><textarea spellCheck="false" readOnly={true} value={prcOpenBookData.doc_fact || ""} style={{border:"4px solid #000", width:"360px",minHeight:"80px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                      </Box>
                    </Box>
                  </Box>

                </Box>
                <Box>
                  <Box sx={{margin:"2px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Common_knowledge</Box>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"8px", alignItems:"center", height:"200px", overflow:"auto" ,border:"4px solid #000"}}>
                      {common_knowledge && common_knowledge.map((item:any, index:any) => 
                          <Box key={"Boxck"+index} sx={{display:"flex", margin:"8px 0px 0px 2px", fontWeight:700}}>
                            <Box sx={{ width: "28px", fontWeight: 700, lineHeight: "28px" }}>{index + 1}.</Box>
                            <textarea key={index} readOnly={true} spellCheck="false" value={item.fact || ""}   style={{width:"440px",minHeight:"24px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  />
                          </Box>
                        )}
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"100%", marginTop: "16px"}}>
                <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#fff9c1"}}>
                  <Box sx={{margin:"4px 4px 4px 4px"}}>
                    <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px", width:"420px"}}>
                      <Box sx={{fontSize:"24px", fontWeight:700, textAlign:"center", margin:"2px"}}>추론경로(CoT)</Box>
                      </Box>
                      <Box><Button sx={{backgroundColor:"#9169ff"}} variant="contained" onClick={handleAdd}>항목 추가</Button></Box>
                    </Box>
                  </Box>
  
                  <Box sx={{width:"840px",margin:"4px", height:"240px", overflow:"auto"}}>
                    <Box sx={{margin:"4px 0px 4px 2px", color:"#4664b4", fontWeight:700}}>Reason Path ({reason_path && reason_path.length})</Box>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"8px", alignItems:"center"}}>
                        {reason_path && reason_path.map((item:any, index:any) => 
                          <Box key={"Box"+index} sx={{display:"flex", margin:"8px 0px 0px 2px", fontWeight:700}}>
                            <Box sx={{ width: "28px", fontWeight: 700, lineHeight: "28px" }}>{index + 1}.</Box>
                            <textarea key={index} spellCheck="false" value={item || ""}  onChange={(e) => reason_path_change(index, e.target.value)} style={{width:"720px",minHeight:"20px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  />
                            <DangerousRoundedIcon sx={{marginLeft:"8px"}} onClick={() => handleRemove(index)}>✕</DangerousRoundedIcon>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                  
                  <Box display="flex">
                    <Box sx={{display:"flex", marginTop:"16px"}}>
                      <Box sx={{display:"flex",marginLeft:"4px"}}>
                        <Box sx={{margin:"8px 12px 0px 4px",width:"32px", fontWeight:700}}>비고</Box>
                        <Box><textarea value={(prcOpenBookData.des === "None" ? "" : prcOpenBookData.des) || ""} onChange={(e) => {setPrcOpenBookData({ ...prcOpenBookData, des: e.target.value });}} style={{width:"360px",minHeight:"40px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                      </Box>
                    </Box>
                    
                    <Box sx={{width:"100%", marginTop: "8px"}}>
                      <Box display="flex" justifyContent="center">
                        <Button variant="contained" color="primary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                          onClick={() => {
                            updateColEvknData('Y');
                          }}
                        >
                          O (선정)
                        </Button>
                      </Box>
                    </Box>
                    <Box sx={{width:"100%", marginTop: "8px"}}>
                      <Box display="flex" justifyContent="center">
                        <Button variant="contained" color="secondary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                          onClick={() => {
                            updateColEvknData('P');
                          }}
                        >
                          X
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                  
                </Paper>
              </Box>
              
            </Paper>
          </Box>
        </Box>
        
        {/* OPENBOOK */}

        {/* 작업 리스트 */}
        <Box>
        {/* Task 단위 화면 */}
        <Box display="flex" justifyContent="center" >
          <Box sx={{padding:"4px 8px 8px 8px", width:"240px"}}>
            <Box display="flex">
              <Box><img style={{width:"24px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/ko_flag.jpg'} /></Box>
              <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>작업목록</Box>
            </Box>
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <TableContainer sx={{maxHeight:"680px",fontSize:"12px"}}>
              <Table size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>IDX</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>검수</Box></TableCell>
                    {/* <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>유형</Box></TableCell> */}
                    {/* <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>CONCEPT</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>USE_CHECK</Box></TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                {(evknWorkList != undefined && evknWorkList.length > 0) ? evknWorkList.map((row:any, index:number) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: '#e1e1ee' } , backgroundColor:(prcOpenBookData != undefined && row.idx === prcOpenBookData.idx ? "#dbdbef": "#fff")}}
                    onClick={()=> {setPrcOpenBookData(row); setCommon_knowledge(JSON.parse(row.common_knowledge)); setReason_path(JSON.parse(row.reason_path)); if(row.gub_cd !== '1') setOptions(JSON.parse(row.options));}}
                  >
                    <TableCell component="th" scope="row" align="center">{row.idx}</TableCell>
                    <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"38px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px",
                          border: (row.job_yn === "Y" ? "2px solid #27cc2f" : (row.job_yn === "P" ? "2px solid #7427cc" : "#000")), color:"#000" }}>
                        {(row.job_yn === "Y" ? "완료" : (row.job_yn === "P" ? "X" : "미작업"))}
                      </Box>
                    </TableCell>
                  </TableRow>
                  )):<TableRow><TableCell colSpan={2} component="th" scope="row" align="center">데이터가 없습니다.</TableCell></TableRow>}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{marginTop:"12px"}}>
              {pagination !== undefined ? (
                  <>
                  <CustomPagination pagination={pagination} goPage={goPage} />
                  <Box display="flex">
                  <TextField size="small" id="worker" value={c_page} onChange={(e)=>setC_page(e.target.value)} 
                    sx={{width:"60px",height: "23px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} 
                    InputProps={{
                      style: {width: "60px", height:"23px", fontSize:"12px"},
                      inputProps: { 
                        spellCheck: "false" // spellcheck를 false로 설정
                      },
                    }}
                    />
                    <Button variant="contained" sx={{marginLeft:"8px",minWidth: "58px", height:"30px", fontSize:"12px"}} onClick={()=>setPage(Number(c_page))}>
                      이동
                    </Button>
                  </Box>
                  </>
              ) : ""}
            </Box>
          </Box>
          
          
        </Box>
      </Box>
            
      </Box>

    </Paper>
  );
  
  
};

export default EvknOpenBookPage;
